import type { FaireProductEntity } from "../../entity_types/product";

export const p_tg4v4apew5: FaireProductEntity = {
  token: "p_tg4v4apew5",
  type: "product",
  name: "Playing In The Dirt",
  brandName: "Kendrick Home",
  imageUrl:
    "https://cdn.faire.com/fastly/0e1640bc53cb224c07e7d004c4be4c416dd3c8866b950755dfdef2469aa49f49.jpeg",
  priceDollars: 12.36,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/5c8a8c90624a12fa4547bc353b4f8f8b92347732c03d756165aa7e9a840c4848.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
